import "client-only";
import { useSyncExternalStore } from "react";
const subscribe = (callback: () => void) => {
  document.addEventListener("visibilitychange", callback);
  return () => {
    document.removeEventListener("visibilitychange", callback);
  };
};
const getSnapshot = () => document.visibilityState === "visible";
const getServerSnapshot = () => true;

/**
 * Reactively tracks document visibility state.
 *
 * Returns `true` when the page is visible (active tab),
 * `false` when hidden (tab switched, minimized, etc.).
 *
 * Uses `useSyncExternalStore` for tear-safe subscriptions that work
 * correctly with React's concurrent rendering.
 *
 * @returns Current visibility state (true = visible, false = hidden)
 *
 */
export function usePageVisibility() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}